
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-and-shipping-companies",
      function () {
        return require("private-next-pages/storage-and-shipping-companies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-and-shipping-companies"])
      });
    }
  